$(function() {

  /**
   * レビューの投稿をするための評価をします。
   * 星の数が動的に切り替わり、評価数は`input#staf-response-score`の`value`属性に連動します。
   */
  var option = {
    hints: ['1', '2', '3', '4', '5'],
    numberMax: 5,
    starOff: '/img/sensha/form/icon_star_off.svg',
    starOn:  '/img/sensha/form/icon_star_on.svg'
  };
  $('.form-Rating_Stars-stafResponse').raty({
    hints: option.hints,
    numberMax: option.numberMax,
    starOff: option.starOff,
    starOn: option.starOn,
    click: function(score) {
      $('#staf-response-score').attr('value', score);
    }
  });

  $('.form-Rating_Stars-FinishCondition').raty({
    hints: option.hints,
    numberMax: option.numberMax,
    starOff: option.starOff,
    starOn: option.starOn,
    click: function(score) {
      $('#finish-condition-score').attr('value', score);
    }
  });

  $('.form-Rating_Stars-price').raty({
    hints: option.hints,
    numberMax: option.numberMax,
    starOff: option.starOff,
    starOn: option.starOn,
    click: function(score) {
      $('#price-score').attr('value', score);
    }
  });

  $('.form-Rating_Stars-SupportSpeed').raty({
    hints: option.hints,
    numberMax: option.numberMax,
    starOff: option.starOff,
    starOn: option.starOn,
    click: function(score) {
      $('#support-speed-score').attr('value', score);
    }
  });

  $('.form-Rating_Stars-confirm').raty({
    hints: option.hints,
    numberMax: option.numberMax,
    starOff: option.starOff,
    starOn: option.starOn,
    readOnly: true
  });

}());
